import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ApptukuApp from './components/ApptukuApp';
import { AuthProvider } from './components/AuthProvider';
// SVGインポートはvite-plugin-svgrで処理されます
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <ApptukuApp />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;